import { httpClient } from '@/modules/common/services/http/http-client';

import {
  IMarginAllocationV2,
  IMarginAllocationPreviewV2
} from './margin-allocation-types';

export const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/trading`
});

export function getMarginAllocationV2(): Promise<IMarginAllocationV2> {
  return http.get(`/v2/margin-allocation`);
}

export function getMarginAllocationPreviewV2(): Promise<IMarginAllocationPreviewV2> {
  return http.get(`/v2/margin-allocation/preview`);
}

export function updateLimitsV2(params: {
  marginCapital: number;
  dailyLoss: number;
  account: string;
}): Promise<IMarginAllocationV2> {
  return http.post(`/v2/margin-allocation`, params);
}

export function updateTraderShield(accountId: string): Promise<{
  isTraderShieldEnabled: boolean;
}> {
  return http.put(`/margin-allocation/traderShield/${accountId}`);
}

export function updatePreferences(accountId: string): Promise<void> {
  return http.put(`/margin-allocation/savePreferences/${accountId}`);
}
